import * as constants from './constants';

export const initialState = {
  list: {},
  item: {},
  statuses: [],
  offices: [], // привязка офисов к сотрудникам
  officesUserId: null, // UserId - пользователь, данные по которому находятся в  offices
  error: null,
  newUser: {},
  avatar: '',
  avatarError: null,
  // listOfAll переехал в MobX userStore.usersByPartnerId (UserSelector, CarmenUsers)
  lastCheckedEmail: null,
  lastCheckedEmailResponse: null,
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_USER_STATUS_SUCCESS:
    case constants.FETCH_USER_STATUS_FAIL:
    case constants.FETCH_USERS_SUCCESS:
    case constants.FETCH_USERS_FAIL:
    case constants.FETCH_USER_SUCCESS:
    case constants.FETCH_USER_FAIL:
    case constants.CREATE_USER_SUCCESS:
    case constants.CREATE_USER_FAIL:
    case constants.UPDATE_USER_SUCCESS:
    case constants.UPDATE_USER_FAIL:
    case constants.DELETE_USER_SUCCESS:
    case constants.DELETE_USER_FAIL:
    case constants.GET_USER_AVATAR:
    case constants.GET_USER_AVATAR_SUCCESS:
    case constants.GET_USER_AVATAR_FAIL:
    case constants.SET_USER_AVATAR_SUCCESS:
    case constants.SET_USER_AVATAR_FAIL:
    case constants.FETCH_OFFICE_USER_SUCCESS:
    case constants.FETCH_OFFICE_USER_FAIL:
    case constants.UPDATE_OFFICE_USER_REDUX:
    case constants.CREATE_OFFICE_USER_SUCCESS:
    case constants.CREATE_OFFICE_USER_FAIL:
    case constants.DELETE_OFFICE_USER_SUCCESS:
    case constants.DELETE_OFFICE_USER_FAIL:
    case constants.REINVITE_USER_SUCCESS:
    case constants.REINVITE_USER_FAIL:
    case constants.DELETE_USER_PARTNER_APP_LOGIN_SUCCESS:
    case constants.DELETE_USER_PARTNER_APP_LOGIN_FAIL:
    case constants.CHECK_EMAIL_SUCCESS:
    case constants.CHECK_EMAIL_FAIL:
    case constants.CHECK_EMAIL:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default usersReducer;
